const createFilterQuery = (values: string[], fieldName: string): string => {
  const conditions = values.map((value: string) => `FIND('${value}', ARRAYJOIN({${fieldName}}))`);
  return `OR(${conditions.join(', ')})`;
};

export default createFilterQuery;
